import type { SVGProps } from "react";
export const Il = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 134 130"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M0 0L16.271 0.777281L31.1862 0V0.971598C22.8569 1.94321 22.0821 7.38417 22.0821 32.6457V96.9656C22.0821 122.227 22.8569 128.057 31.1862 129.028V130L15.6899 129.223L0 130V129.028C8.32922 128.057 9.10403 122.227 9.10403 96.9656V32.6457C9.10403 7.38417 8.32922 1.94321 0 0.971598V0Z"
			fill="#A3CFF5"
		/>
		<path
			d="M56.3252 0L72.4025 0.777281L87.8987 0V0.971598C79.5695 1.94321 78.7947 7.38417 78.7947 32.6457V93.0792L80.7317 120.284L102.62 119.507C124.121 118.729 127.995 118.146 133.031 109.985H134L132.063 130L78.9884 129.223L56.3252 130V129.028C64.6544 128.057 65.4292 122.227 65.4292 96.9656V32.6457C65.4292 7.38417 64.6544 1.94321 56.3252 0.971598V0Z"
			fill="#A3CFF5"
		/>
	</svg>
);
